export enum AuthorisationRoles {
  'Digital Eye' = '3bbeb905-bf75-4067-b732-610e16366f55',
  ADMIN = '6bfa6bd7-806d-4e7c-a82a-3b4bb3c45051',

  DATA_CONSUMERS = 'd09b71a5-151e-41dc-8172-7a10fa43dfa9',

  SUPERUSERS = 'd7601308-1df1-401d-96a2-700f3eac0bcf',
}
